import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { useTranslation } from "react-i18next"
import {
  getJobApplicationTimeline,
  verifyActionOtp,
  withdrawnJobApplication,
} from "store/actions/jobApplicationAction"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { InputOtp } from "primereact/inputotp"

const Timeline = () => {
  const { t } = useTranslation()

  document.title = t("Profile | SAR")
  const dispatch = useDispatch()
  const { loading, isLoading, timeLine, enabled_withdrawn_action } =
    useSelector(state => state.JobApplication)
  const [sessionId, setSessionId] = useState(null)
  const [modal, setModal] = useState(false)
  const [otp, setOtp] = useState("")

  const toggle = () => setModal(!modal)

  useEffect(() => {
    fetchTimelineData()
  }, [])

  const fetchTimelineData = () => {
    dispatch(getJobApplicationTimeline())
  }

  const statusGroups = [
    [
      { status: "Application Submitted", timestamp: "2025-16-2 10:00 AM" },
      { status: "Interview", timestamp: "" },
      { status: "Theoratical Training", timestamp: "" },
      { status: "Practical Training", timestamp: "" },
    ],
    // [
    //   { status: 'interview_scheduled', timestamp: '2023-10-05 02:00 PM' },
    //   { status: 'interview_passed', timestamp: '2023-10-06 10:30 AM' },
    //   { status: 'interview_failed', timestamp: '2023-10-07 01:15 PM' },
    //   { status: 'interview_not_attended', timestamp: '2023-10-08 04:00 PM' },
    // ],
  ]

  const currentStatus = "Application Submitted" // This should be dynamically set based on the user's actual status
  const isRejected = currentStatus === "rejected" // Check if the current status is "rejected"

  // Flatten the status groups into a single array for the timeline
  const statuses = statusGroups.flat()

  const handleWithdrawnJobApplication = () => {
    dispatch(withdrawnJobApplication())
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          const { sessionId } = data
          console.log(data)
          setSessionId(sessionId)
          dispatch(showAlert({ text: message, type: "success" }))
          toggle()
          // fetchTimelineData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleOtpVerification = () => {
    const payload = {
      type: "application_withdrawn",
      sessionId,
      otp,
    }
    dispatch(verifyActionOtp(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          const { sessionId } = data
          setSessionId(null)
          setOtp(null)
          dispatch(showAlert({ text: message, type: "success" }))
          fetchTimelineData()
          toggle()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <div className="g_between mb-3">
              <h4 className="card-title">Time line Status</h4>
            </div>
          </Row>

          {loading ? (
            <Spinners />
          ) : (
            <Card>
              <CardBody>
                <div className="timeline-container">
                  <div className="timeline-container">
                    {timeLine?.map((group, groupIndex) => (
                      <div key={groupIndex} className="timeline-group">
                        {/* <div className="timeline-line"></div>{" "} */}
                        <div
                          className={`timeline-line ${
                            group.length ? `item_${group.length}` : ""
                          }`}
                        ></div>
                        {/* Timeline line */}
                        <div className="timeline-items">
                          {group.map((statusObj, index) => (
                            <div key={statusObj.id} className="timeline-item">
                              <div className="timeline-step">
                                {" "}
                                {groupIndex === 0
                                  ? index + 1
                                  : statusGroups?.slice(0, groupIndex).flat()
                                      .length +
                                    index +
                                    1}
                              </div>
                              <div className="timeline-content">
                                <span>
                                  {statusObj.status.replace(/_/g, " ")}
                                </span>
                                <div className="timeline-timestamp">
                                  {statusObj.timestamp}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        {groupIndex < statusGroups.length - 1 && (
                          <div className="timeline-separator" />
                        )}
                      </div>
                    ))}
                  </div>

                  {enabled_withdrawn_action && (
                    <div>
                      <Button
                        color="danger"
                        className="d-block mx-auto px-4 py-2 fs-4"
                        onClick={handleWithdrawnJobApplication}
                        disabled={isLoading}
                      >
                        Withdraw Application
                      </Button>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Verify OTP</ModalHeader>
        <ModalBody>
          <div className="otp_section">
            <InputOtp
              value={otp}
              onChange={e => setOtp(e.value)}
              length={6}
              pt={{ root: { placeholder: "------" } }}
              mask
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleOtpVerification}
            disabled={otp?.length !== 6 || isLoading}
          >
            Verify
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default Timeline
